import { useCallback, useContext, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AnalyticsManager from '../../analytics/AnalyticsManager'
import useShortcuts from '../../hooks/useShortcuts'
import useSelectView from '../../hooks/useSelectView'
import { selectActiveChartId } from '../../selectors/chart'
import { ChartViewKey } from '../../assets/constants'
import { AppContext } from '../../App'
import { ChartShortcutsKeyName } from './ShortcutsKeymap'
import { ShortcutsCategories, ShortcutType } from './Shortcuts.types'
import { toggleAppFullScreen } from './toggleAppFullScreen'

const ChartShortcutsRegister = () => {
    const dispatch = useDispatch()
    const view = useSelectView()
    const activeChartId = useSelector(selectActiveChartId)
    const appContext = useContext(AppContext)

    const toggleFullScreen = useCallback(() => {
        toggleAppFullScreen(dispatch, appContext, view, 'keyboard')
    }, [appContext, dispatch, view])

    const shortcuts: ShortcutType = useMemo(() => {
        const chart = appContext.getChart(activeChartId)
        const map: ShortcutType = {
            [ChartShortcutsKeyName.showHideFullScreen]: toggleFullScreen,
        }
        if (chart?.resetTimeScale) {
            map[ChartShortcutsKeyName.resetChartView] = () => {
                AnalyticsManager.logEvent('Reset Chart View', { source: 'keyboard' })
                chart.resetTimeScale()
            }
        }
        map[ChartShortcutsKeyName.scrollToRecentBar] = () => {
            const activeChart = appContext.getChart(activeChartId)
            if (activeChart?.gotoCurrentTime) {
                activeChart.gotoCurrentTime()
                return
            }
            appContext.getMultiStrikeChart(ChartViewKey.MULTI_STRIKES_CHART)?.gotoCurrentTime()
        }
        return map
    }, [activeChartId, appContext, toggleFullScreen])

    useShortcuts(ShortcutsCategories.CHART, shortcuts)
}

export default ChartShortcutsRegister
